import { render, staticRenderFns } from "./team-config-list.vue?vue&type=template&id=2046950b&"
import script from "./team-config-list.vue?vue&type=script&lang=js&"
export * from "./team-config-list.vue?vue&type=script&lang=js&"
import style0 from "./team-config-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports